export const BALANCE_SLICE_NAME = "balance"
